import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { SwapFreeOptionDtoFilterKey } from 'api/Clients/Types/SwapFreeOptionDto'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { BooleanFilter } from './BooleanFilter'
import { CountryFilter } from './common.filter'

export const getSwapFreeOptionsFields = (): FieldSettings[] => [
  {
    name: SwapFreeOptionDtoFilterKey.countryId,
    label: 'Country',
    filter: CountryFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: SwapFreeOptionDtoFilterKey.green,
    label: 'Green',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.gtOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.gteOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.ltOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.lteOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
    ],
  },
  {
    name: SwapFreeOptionDtoFilterKey.red,
    label: 'Red',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.gtOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.gteOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.ltOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.lteOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
    ],
  },
  {
    name: SwapFreeOptionDtoFilterKey.daysTillSuspended,
    label: 'Days Till Suspended',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.gtOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.gteOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.ltOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.lteOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
    ],
  },
  {
    name: SwapFreeOptionDtoFilterKey.enabled,
    label: 'Enabled',
    filter: BooleanFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
]
